import { render, staticRenderFns } from "./WechartQR.vue?vue&type=template&id=37002d0b&scoped=true&"
import script from "./WechartQR.vue?vue&type=script&lang=ts&"
export * from "./WechartQR.vue?vue&type=script&lang=ts&"
import style0 from "./WechartQR.vue?vue&type=style&index=0&id=37002d0b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37002d0b",
  null
  
)

export default component.exports